import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import * as employeeApi from '../../../lib/api/employee';
import { useDispatch, useSelector } from 'react-redux';


import { listApprovalLine } from '../../../modules/empModule/empApproval';
import ApprovalLineForm from '../../../components/profilemng/approval/ApprovalLineForm';

const ApprovalFormContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();


  const initialValues = {
    apprNm: '',
    usrUuid1: '',
    usrName1: '',
    usrUuid2: '',
    usrName2: '',
    usrUuid3: '',
    usrName3: '',
    usrUuid4: '',
    usrName4: '',
    usrUuid5: '',
    usrName5: '',
  };

  const validationSchema = yup.object({
    apprNm: yup.string('').required('결재선명을 입력하세요'),
    usrName1: yup.string('').required('결재자1을 선택하세요'),
    usrName2: yup.string('').nullable('결재자2을 선택하세요'),
    usrName3: yup.string('').nullable('결재자3을 선택하세요'),
    usrName4: yup.string('').nullable(''),
    usrName5: yup.string('').nullable(''),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        apprNm: values.apprNm,
        usrUuid1: values.usrUuid1,
        usrUuid2: values.usrUuid2,
        usrUuid3: values.usrUuid3,
        usrUuid4: values.usrUuid4,
        usrUuid5: values.usrUuid5,
      };
      console.log(dataToSubmit, 'dataToSubmit');

      try {
        const response = await employeeApi.addApprovalLine(dataToSubmit);
        if (response.data) {
          dispatch(listApprovalLine());
        }
        enqueueSnackbar('결재선 저장 성공', {
          variant: 'success',
        });
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <ApprovalLineForm formik={formik} />;
};

export default ApprovalFormContainer;
